import React, { useEffect } from 'react'

import { CountryCode } from '@guiker/base-entity'
import { useGlosseryDrawerContext } from '@guiker/glossery-drawer'
import { useAuthenticatedPropSharingInvestorProfileContext } from '@guiker/propsharing-context'
import { AuthApi, InvestorProfile } from '@guiker/propsharing-shared'
import { ApiFormStep, StepProps, useApiFormStepContext, yupResolver } from '@guiker/react-framework'
import { AboutYouFormContent } from '@guiker/user-components'

import { Paragraph } from './Typography'

const schema = AuthApi.Schema.updateInvestorProfileStepperSchema.AboutYou

const DrawerContent: React.FC = () => {
  return <Paragraph transKey='main-propsharing:screens.createInvestorProfileScreen.step2.helperText.personalInfo' />
}

export const AboutYou: React.FC<StepProps> = (props) => {
  const { data: investorProfile } = useApiFormStepContext<InvestorProfile>()
  const { apiClient } = useAuthenticatedPropSharingInvestorProfileContext()
  const resolver = yupResolver(schema)
  const { anchor, setContent, onClose } = useGlosseryDrawerContext()

  useEffect(() => {
    setContent(DrawerContent)
    return () => {
      onClose()
    }
  }, [])

  const onSubmit = (payload: AuthApi.Schema.UpdateInvestorProfileStepperSchema['AboutYou']) => {
    return apiClient.updateInvestorProfileStepAboutYou({
      payload: schema.cast(payload, { stripUnknown: true }),
    })
  }

  return (
    <ApiFormStep
      {...props}
      isContentDrawerOpened={!!anchor}
      apiFormProps={{
        formName: 'CreateInvestorProfile',
        onSubmit,
        formOptions: {
          resolver,
          defaultValues: {
            ...investorProfile?.personal,
            address: {
              ...investorProfile?.personal?.address,
              country: CountryCode.CA,
            },
          },
        },
      }}
    >
      <AboutYouFormContent defaultValue={investorProfile?.personal} />
    </ApiFormStep>
  )
}
